<template>
    <div class="page">
        <div class="page_content">
            <div class="title_bg" data-aos="fade-down" data-aos-duration="600">
                <img class="img_base" src="../assets/images/insight_bg.jpg" alt="">
                <div class="page_title">{{text.title[lang]}}</div>
            </div>
            <div class="content_box">
                <div class="content_left">
                    <div class="content_left_top">
                        <div class="content_left_top_item content_item" data-aos="fade-down" :data-aos-duration="600 + 100 * index" :data-aos-delay="200 - 100 * index" v-for="(item, index) in text.articles1.slice(0, 2)" :key="index">
                            <div class="content_img">
                                <img :src="item.img" alt="">
                            </div>
                            <div class="content_title" @click="toPage(item.url, item.routerUrl)">{{item.title[lang]}}</div>
                            <div class="content_text">{{item.content[lang]}}</div>
                        </div>
                    </div>
                    <div class="content_left_bottom content_item_2" data-aos="fade-down" data-aos-duration="800" data-aos-delay="100">
                        <div class="content_img">
                            <img :src="text.articles1[2].img" alt="">
                        </div>
                        <div class="content_title" @click="toPage(text.articles1[2].url, text.articles1[2].routerUrl)">{{text.articles1[2].title[lang]}}</div>
                        <div class="content_text">{{text.articles1[2].content[lang]}}</div>
                    </div>
                </div>
                <div class="content_right content_item_2" data-aos="fade-down" data-aos-duration="500">
                    <div class="content_img_2">
                        <img class="img_base" :src="text.articles1[3].img" alt="">
                    </div>
                    <div class="content_title" @click="toPage(text.articles1[3].url, text.articles1[3].routerUrl)">{{text.articles1[3].title[lang]}}</div>
                    <div class="content_text">{{text.articles1[3].content[lang]}}</div>
                </div>
            </div>
            <div class="element">
                <div data-aos="fade-down" :data-aos-duration="600 + 100 * index" :data-aos-delay="200 - 100 * index" :class="{'element_item': true, 'element_line': index < text.element.length - 1}" v-for="(item, index) in text.element" :key="index">
                    <div class="element_title">{{item.title[lang]}}</div>
                    <div class="element_img">
                        <img class="img_base" :src="item.img" alt="">
                    </div>
                    <div class="element_content">{{item.content[lang]}}</div>
                </div>
            </div>
            <div class="content_box" data-aos="fade-down" data-aos-duration="800" data-aos-delay="100">
                <div class="content_item" v-for="(item, index) in text.articles2" :key="index">
                    <div class="content_img">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="content_title" @click="toPage(item.url, item.routerUrl)">{{item.title[lang]}}</div>
                    <div class="content_text">{{item.content[lang]}}</div>
                </div>
            </div>
        </div>
        <Foot/>
        <Nav></Nav>
    </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
import {insightText} from '@/js/text.js'
import {wxShare} from '@/js/api.js'
export default {
    components: {
        Nav,
        Foot
    },
    data () {
        return {
            text: insightText,
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        }
    },
    methods: {
        showMessage () {
            this.$alert('文章尚在开发中，敬请期待', '提示', {
                confirmButtonText: '确定'
            })
        },
        toPage (url, routerUrl) {
            if (url !== '') {
                window.open(url)
            } else if (routerUrl !== '') {
                if (this.$route.path !== routerUrl) {
                    this.$router.push({path: routerUrl})
                }
            } else {
                this.showMessage()
            }
            
        }
    },
    mounted () {
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '用户', '进入', '最新洞察'])
        const url = location.href
        var shareInfo = {
            title: '为客户提供增长落地方案',
            desc: 'Deansel专注于解决客户在新生态下的增长方案'
        }
        wxShare(url, shareInfo)
    },
}
</script>

<style scoped>
.page_title {
    width: 80%;
    position: absolute;
    bottom: 10%;
    left: 10%;
    /* transform: translateY(-50%); */
    font-size: 2.25rem;
    font-weight: 500;
    line-height: 1.5;
    text-align: left;
    color: #fff;
}
.title_bg {
    width: 100vw;
    height: 100vh;
    margin-bottom: 10%;
    background: #B6ADB4;
}
.title_bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.content_box {
    width: 82vw;
    margin: 0 9% 5% 9%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
.content_item {
    width: 19vw;
    margin-right: 2vw;
    position: relative;
    text-align: left;
    box-sizing: border-box;
    padding: 1vw;
}
.content_item:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.content_item_2 {
    position: relative;
    text-align: left;
    box-sizing: border-box;
    padding: 1vw;
}
.content_item_2:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.content_item:nth-last-child(1) {
    margin-right: 0;
}
.content_img {
    width: 100%;
}
.content_img img {
    width: 100%;
}
.content_img_2 {
    width: 38vw;
    height: 60vw;
}
.content_title {
    width: 100%;
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1.5;
    margin: 2vw auto;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.content_title:hover {
    text-decoration: underline;
    color: #1F40E6;
    cursor: pointer;
}
.content_text {
    width: 100%;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-bottom: 2vw;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
}
.content_text:hover {
    display: block;
}
.content_left {
    width: 40vw;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.content_left_top {
    width: 100%;
    margin-bottom: 10%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
.content_left_top_item {
    width: 19vw;
}
.content_left_bottom {
    width: 100%;
}
.element {
    width: 100%;
    margin-bottom: 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.content_right {
    width: 40vw;
}
.element_item {
    flex: 1;
    /* height: 32vw; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: left;
    line-height: 1.5;
}
.element_title {
    width: 70%;
    font-size: 0.875rem;
    font-weight: bold;
    margin-top: 10%;
    text-align: center;
}
.element_img {
    width: 5vw;
    height: 5vw;
    overflow: hidden;
    margin: 2vw auto 3vw auto;
}
.element_content {
    width: 70%;
    font-size: 0.875rem;
    margin-bottom: 10%;
    text-decoration: none;
}
.element_line {
    border-right: 1px solid #d5d5d5;
}
@media screen and (max-width: 756px) {
    .content_box {
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }
    .content_item {
        width: 82vw;
        margin: 0 auto 5% auto;
        padding: 1vw;
    }
    .content_item_2 {
        margin: 0 auto 5% auto;
        position: relative;
        text-align: left;
        box-sizing: border-box;
        padding: 1vw;
    }
    .content_item:nth-last-child(1) {
        margin-right: 0;
    }
    .content_img {
        width: 100%;
        height: 50vw;
    }
    .content_img img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .content_img_2 {
        width: 100%;
        height: 50vw;
    }
    .content_title {
        overflow: visible;
        display: block;
    }
    .content_text {
        width: 100%;
        overflow: visible;
        display: block;
    }
    .content_left {
        width: 100%;
    }
    .content_left_top {
        width: 100%;
        margin-bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }
    .content_left_top_item {
        width: 100%;
    }
    .content_left_bottom {
        width: 100%;
    }
    .content_right {
        width: 100%;
    }
}
</style>
